import React from "react";
import { useDispatch } from "react-redux";

import { updateUser } from "src/features/auth/actions";
import { User } from "src/features/auth/types";
import { AppDispatch } from "src/store";

export function useUpdateUser(): (user: Partial<User>) => void {
	const dispatch: AppDispatch = useDispatch();
	return React.useCallback(
		(user: Partial<User>) => {
			dispatch(updateUser(user));
		},
		[dispatch]
	);
}
